// ═══════════════════════════════════════════════════════════════════════════════
// Format API UTC datetimes (YYYY-MM-DD hh:mm) for the viewer's timezone
// ═══════════════════════════════════════════════════════════════════════════════

import { LANGUAGE } from '@fdh/shared';
import { resolveDisplayTimeZone } from './userTodayYmd';

export const parseUtcDatetime = (value: string): Date | null => {
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/);
  if (!match) {
    return null;
  }
  const [, year, month, day, hour, minute] = match;
  return new Date(
    Date.UTC(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      0,
      0,
    ),
  );
};

export const mapLanguageToLocale = (language: string): string => {
  if (language === LANGUAGE.ZH_HANT) {
    return 'zh-Hant-HK';
  }
  if (language === LANGUAGE.ZH_HANS) {
    return 'zh-Hans-CN';
  }
  if (language === LANGUAGE.ID) {
    return 'id-ID';
  }
  if (language === LANGUAGE.FIL) {
    return 'fil-PH';
  }
  return 'en-US';
};

/** Convert API UTC `YYYY-MM-DD hh:mm` to the same pattern in the user/display timezone. */
export const formatUtcForUserTimezone = (
  value: string | null | undefined,
  timezone: string | null | undefined,
  locale: string,
): string => {
  if (!value) {
    return '-';
  }
  const date = parseUtcDatetime(value);
  if (!date) {
    return value;
  }
  const parts = new Intl.DateTimeFormat(locale, {
    timeZone: resolveDisplayTimeZone(timezone),
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(date);
  const byType = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  const year = byType.year ?? '0000';
  const month = byType.month ?? '01';
  const day = byType.day ?? '01';
  const hour = byType.hour ?? '00';
  const minute = byType.minute ?? '00';
  return `${year}-${month}-${day} ${hour}:${minute}`;
};
